/**
 * @file mlrRichTextContext.ts
 * @brief Focused TipTap instance + hook for the MLR format toolbar.
 *
 * @details
 * Split from the provider `.tsx` so Fast Refresh can hot-swap the provider
 * (same pattern as `shared/auth/auth-context.ts`) (08-09-2026).
 *
 * @references WEBPANEL/src/features/medical-assessment/components/MlrRichTextProvider.tsx
 * @author DES
 * @date 08-09-2026
 */

import { createContext, useContext } from "react";
import type { Editor } from "@tiptap/react";

export type MlrRichTextContextValue = {
  editor: Editor | null;
  setFocusedEditor: (editor: Editor | null) => void;
  clearIfFocused: (editor: Editor | null) => void;
};

export const MlrRichTextContext = createContext<MlrRichTextContextValue | null>(
  null,
);

export function useMlrRichText(): MlrRichTextContextValue {
  const ctx = useContext(MlrRichTextContext);
  if (!ctx) {
    return {
      editor: null,
      setFocusedEditor: () => undefined,
      clearIfFocused: () => undefined,
    };
  }
  return ctx;
}
